module.exports = __webpack_public_path__ + "8dee5f9957cc9fadcfcfcdc38d240064.svg";